import request from '@/utils/request';

// post /api/v1/admin/game_config/banner/create 轮播广告创建
export function createBanner(data) {
  return request({
    url: '/api/v1/admin/game_config/banner/create',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/banner/delete 轮播广告删除
export function deleteBanner(data) {
  return request({
    url: '/api/v1/admin/game_config/banner/delete',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/banner/get 轮播广告详情
export function getBannerDetail(data) {
  return request({
    url: '/api/v1/admin/game_config/banner/get',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/banner/list 轮播广告列表
export function getBannerList(data) {
  return request({
    url: '/api/v1/admin/game_config/banner/list',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/game_config/banner/update 轮播广告更新
export function updateBanner(data) {
  return request({
    url: '/api/v1/admin/game_config/banner/update',
    method: 'post',
    data,
    mock: false,
  })
}
